<div class="w-100">
  <div>
    <mwp-card-content-header [url]="apiUrl" />
  </div>
  <div class="row">
    <div class="col-6 mb-3">
      @if (displayModePanel) {
        <div class="mb-3">
            <mwp-benefit-enrollment-onboarding-wizard-mode [enrolmentOnboardModel]='enrolmentOnboardModel' (emitComplete)='processPanel($event)' (emitContinueSession)="continueSession()"/>
        </div>
      }
      @if (member) {
        <mwp-profile-info [member]="member" />
      }
    </div>
    <div class="col-6">
      <mwp-member-benefits />
    </div>
  </div>
</div>